export default __webpack_public_path__ + "static/media/icon-social-mention.cd023ba5.svg";